import { Component } from '@angular/core';
import { SliderItem } from '@frogo-kit/core';

@Component({
  selector: 'aft-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: false,
})
export class AuthComponent {
  public sliderItems: SliderItem[] = [
    {
      title: 'Protect your business with <span>AI-powered</span> tools',
      content: 'Frogo’s smart algorithms analyze thousands of signals in real time, stopping fraudsters before they strike.',
    },
    {
      title: 'Make <span>faster, smarter</span> decisions',
      content: 'Our adaptive scoring engine fine-tunes itself, reducing false positives and catching actual threats instantly.',
    },
    {
      title: 'Expose <span>hidden fraud networks</span> in seconds',
      content: 'Reveal connections between suspicious accounts, ' +
        'transactions, and devices in just a few clicks with our graph-based investigations.',
    },
    {
      title: '<span>Stay ahead</span> of evolving fraud tactics',
      content: 'Our AI learns from every interaction, identifying anomalies, ' +
        'detecting bonus abuse, and stopping multi-accounting before it impacts your business.',
    },
    {
      title: '<span>Catch threats</span> before they cost you',
      content: 'Keep your revenue safe with instant transaction analysis. Detect unusual patterns and flag risky behavior.',
    },
    {
      title: 'React in real time, <span>anytime</span>',
      content: 'Stay in the loop with instant fraud alerts via email, messengers, or in-app notifications. ' +
        'Get the info you need, when you need it.',
    },
  ];
}
